var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "cart-panel" }, [
    _c("div", { staticClass: "cart-header" }, [
      _c("span", [_vm._v("已选商品（" + _vm._s(_vm.items.length) + " 种）")]),
      _c(
        "a",
        {
          staticClass: "cart-clear",
          on: {
            click: function ($event) {
              return _vm.$emit("clear")
            },
          },
        },
        [_vm._v("清空")]
      ),
    ]),
    _c(
      "div",
      { staticClass: "cart-list" },
      [
        _vm._l(_vm.items, function (item, index) {
          return _c("div", { key: item.key, staticClass: "cart-row" }, [
            _c("div", { staticClass: "row-main" }, [
              _c(
                "div",
                { staticClass: "row-name" },
                [
                  _vm._v("\n          " + _vm._s(item.name) + "\n          "),
                  _c("span", { staticClass: "row-unit" }, [
                    _vm._v("（" + _vm._s(item.unit) + "）"),
                  ]),
                  item.priceChanged
                    ? _c(
                        "a-tag",
                        {
                          staticClass: "row-changed",
                          attrs: { color: "orange" },
                        },
                        [_vm._v("改")]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "row-ctrl" },
                [
                  _c("div", { staticClass: "stepper" }, [
                    _c(
                      "a",
                      {
                        staticClass: "step-btn",
                        on: {
                          click: function ($event) {
                            return _vm.changeNumber(index, -1)
                          },
                        },
                      },
                      [_vm._v("−")]
                    ),
                    _c("input", {
                      staticClass: "step-input",
                      attrs: { inputmode: "decimal" },
                      domProps: { value: item.operNumber },
                      on: {
                        change: function ($event) {
                          return _vm.onNumberInput(index, $event)
                        },
                      },
                    }),
                    _c(
                      "a",
                      {
                        staticClass: "step-btn",
                        on: {
                          click: function ($event) {
                            return _vm.changeNumber(index, 1)
                          },
                        },
                      },
                      [_vm._v("＋")]
                    ),
                  ]),
                  _c("div", { staticClass: "row-price" }, [
                    _c(
                      "div",
                      {
                        staticClass: "row-unit-price",
                        attrs: { title: "点击改价" },
                        on: {
                          click: function ($event) {
                            return _vm.startEditPrice(index)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n              ¥" +
                            _vm._s(_vm.format(item.unitPrice)) +
                            "\n            "
                        ),
                      ]
                    ),
                    _c("div", { staticClass: "row-all-price" }, [
                      _vm._v(
                        "¥" +
                          _vm._s(_vm.format(item.unitPrice * item.operNumber))
                      ),
                    ]),
                  ]),
                  _c("a-icon", {
                    staticClass: "row-remove",
                    attrs: { type: "close" },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("remove", index)
                      },
                    },
                  }),
                ],
                1
              ),
              _vm.editingPriceIndex === index
                ? _c(
                    "div",
                    { staticClass: "price-edit" },
                    [
                      _c("span", [_vm._v("改价：")]),
                      _c("a-input-number", {
                        staticStyle: { width: "100px" },
                        attrs: { min: 0, size: "small", precision: 2 },
                        on: { pressEnter: _vm.confirmPrice },
                        model: {
                          value: _vm.editingPrice,
                          callback: function ($$v) {
                            _vm.editingPrice = $$v
                          },
                          expression: "editingPrice",
                        },
                      }),
                      _c(
                        "a-button",
                        {
                          attrs: { size: "small", type: "primary" },
                          on: { click: _vm.confirmPrice },
                        },
                        [_vm._v("确定")]
                      ),
                      _c(
                        "a-button",
                        {
                          attrs: { size: "small" },
                          on: {
                            click: function ($event) {
                              _vm.editingPriceIndex = -1
                            },
                          },
                        },
                        [_vm._v("取消")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ]),
          ])
        }),
        !_vm.items.length
          ? _c(
              "div",
              { staticClass: "cart-empty" },
              [
                _c("a-icon", { attrs: { type: "shopping-cart" } }),
                _c("div", [_vm._v("点击左侧商品加入购物车")]),
                _c("div", { staticClass: "cart-empty-tip" }, [
                  _vm._v("支持扫码枪输入条码直接入车"),
                ]),
              ],
              1
            )
          : _vm._e(),
      ],
      2
    ),
    _c(
      "div",
      { staticClass: "cart-footer" },
      [
        _c("div", { staticClass: "summary-row" }, [
          _c("span", [_vm._v("件数：" + _vm._s(_vm.totalCount))]),
          _c("span", [
            _vm._v("原价合计：¥" + _vm._s(_vm.format(_vm.originTotal))),
          ]),
        ]),
        _c("div", { staticClass: "summary-row" }, [
          _c("span", [
            _vm._v("会员优惠："),
            _c("span", { staticClass: "discount" }, [
              _vm._v("-¥" + _vm._s(_vm.format(_vm.originTotal - _vm.total))),
            ]),
          ]),
          _vm.member
            ? _c("span", [
                _vm._v(
                  "会员：" + _vm._s(_vm.member.contacts || _vm.member.cardNo)
                ),
              ])
            : _c("span", [_vm._v("散客")]),
        ]),
        _c(
          "a-button",
          {
            staticClass: "settle-btn",
            attrs: {
              type: "primary",
              size: "large",
              block: "",
              disabled: !_vm.items.length,
            },
            on: {
              click: function ($event) {
                return _vm.$emit("settle")
              },
            },
          },
          [
            _vm._v(
              "\n      合计 ¥" +
                _vm._s(_vm.format(_vm.total)) +
                " 结算（F9）\n    "
            ),
          ]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }